import React, { Component, createRef } from 'react';


import { grey, purple } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import PageBase from '../site/PageBase';
//import LiveMap from './LiveMap';
import {apipost, apiraw, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg';
import submit from '../icons/submit.svg';
import process from '../icons/thinking.svg';
import complete from '../icons/task-complete.svg';
import { Box } from '@mui/material';

const s:any = {
  root: {
    flexGrow: 1,
    flexShrink: 1,
  },
  // navigation: {
  //   fontSize: 15,
  //   fontWeight: 300,
  //   color: grey['600'],
  //   paddingBottom: 15,
  //   display: 'block'
  // },
  // title: {
  //   fontSize: 24,
  //   fontWeight: 300,
  //   marginBottom: 20,
  //   color:'white'
  // },
  // paper: {
  //   padding: 5,
  // },
  // clear: {
  //   clear: 'both'
  // },
  boardpaper: {
    backgroundColor: 'white',
    //maxHeight: 600,
    height: '100%',
    // height: 150
    marginLeft: 10,
    marginRight: 10,
  },
  div: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  header: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 10,
  }
};

const metericons:any = {
  NRMMS: {
    "1P":L.icon({iconUrl:apply,shadowUrl:iconShadow}),
    "3P":L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  },
  NFMMS: {
    "1P":L.icon({iconUrl:submit,shadowUrl:iconShadow}),
    "3P":L.icon({iconUrl:process,shadowUrl:iconShadow}),
  }
};

const DEFAULT_MAP_CENTER: [number, number] = [5.64046614, -0.2921927];

const isValidPosition = (p: any): boolean => {
  if (p == null) return false;
  if (Array.isArray(p)) return p.length >= 2 && typeof p[0] === 'number' && typeof p[1] === 'number';
  return typeof (p as { lat?: number; lng?: number }).lat === 'number' && typeof (p as { lat?: number; lng?: number }).lng === 'number';
};

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const MapIcon:L.Class = L.Icon.extend({
  options: {
    iconUrl: metericon,
    iconSize: [7.5, 7.5],
    iconAnchor: [0, 0]
  }
});

class Mapboard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map: any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    this.state = {
      //dd: this.props.userData.dd,
      ping: null,
      timer: 60000, //300000,
      count:0,
      offset: 0,
      limit: 1000,
      loading: false,
      lastread: null,
      recordset: [],
      previousset:[],
      currentset:[],
      maplayer: null,
      center:[5.64046614, -0.2921927],
      zoom: 13,
    };
  }

  // componentDidMount(): void {
  //   // const map = useMap()
  //   // console.log('map center:', map.getCenter())
  //   // return null
  //   const cmap = this.map.current;
  //   console.log('map',cmap);
  //   cmap.on('zoomend',this.onZoom);

  // } 

  componentDidMount() {
    const cmap = this.map.current;
    console.log('map',cmap);
    //cmap.on('zoomend',this.onZoom);
    this.baseload();
    //
    const {timer } = this.state;
    var ping = setInterval(this.refresh,timer);
    this.setState({ ping: ping });
  }

  componentWillUnmount() {
    if (this.state.ping) clearInterval(this.state.ping);
  }

  refresh = async() => {
    try {
      const {center:ocenter,recordset:previousset,lastread} = this.state;
      const {offset:ofs,limit:lim} = this.state;
      const baseparams = { s: "mapboard", a: "get",ofs,lim };
      const response = await bizpost(baseparams);
      const {cc:ncenter,rc,sd:currentset} = response;
      const recordset = this.merge('rid',previousset,currentset);
      const offset = ofs+rc;
      const center = ncenter || ocenter;
      this.setState({center,recordset,previousset,currentset,offset});
    } catch (error) {
      console.log("refresh error", error);
      this.sessionError(error);
    }
  }

  sessionError(error: any) {
    const { type, name, title, data } = error || {};
    if (type === "error" && name === "fetcherror" && title === "Unauthorised") {
      const { failure, code } = data || {};
      if (failure === true && code === 401) {
        //session expired. reload page.
        //this.props.doRestart('Session Expired. reloading...');
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }
  }

  // componentDidMount(){
  //   const {timer} = this.state;
  //   var ping = setInterval(async()=>{
  //     try{
  //       const baseparams = {s:'security',a:'dashdata'};
  //       const response = await bizpost(baseparams);
  //       //console.log('dd resp',response);
  //       this.setState({dd:response.dd});
  //     }
  //     catch(error){
  //       console.log('dd error',error);
  //     } 
  //   },timer);
  //   this.setState({ping:ping});
  // }

  // componentWillUnmount(){
  //   if(this.state.ping) clearInterval(this.state.ping);
  // }

  mapload = async(file:string) => {
    try{
      const baseparams = {file}; //,sta:date
      const response = await apiraw('/api/resource/maps','',baseparams);
      //this.setState({markers:response.sd});
      //this.map.addLayer(this.liveLayer);
      //this.liveLayer.clearLayers();
      //this.loadMakersLeaflet();
      return response; //TODO: return file
    }
    catch(error){
      console.log('mapload error',error);
      return Promise.reject(error);
    } 
  //TODO: call LoadMarkers
  
  }

  baseload = async() => {
    try{
      const rs = await this.mapload('ghana_regions.json');
      console.log('baselayer',rs);
      this.setState({maplayer:rs});
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);


  // liveLoad = async(code:any,date:any) => {
  //     try{
  //       const {recordset:previousset,lastread} = this.state;
  //       const {userData} = this.props || {};
  //       const {eni} = userData;
  //       //const start = moment.format()
  //       //TODO: I am hardcoding code and start until baseparams is properly fixed. start is a timestamp so it will 
  //       // not accept empty string. either null or a valid timestamp
  //       const baseparams = {s:'marker',a:'find',eni,stp:lastread}; //,sta:date, ,cod:'1M8wJEWIAcIEfILnCHpISD'
  //       const response = await bizpost(baseparams);
  //       const {sd:currentset} = response;
  //       const recordset = this.merge('rid',previousset,currentset);
  //       this.setState({recordset,previousset,currentset});
  //       //this.map.addLayer(this.liveLayer);
  //       //this.liveLayer.clearLayers();

  //       //this.loadMakersLeaflet();
  //     }
  //     catch(error){
  //       console.log('map.bizpost error',error);
  //     } 
  //   //TODO: call LoadMarkers
    
  // }

  ttFormatTime = (stamp:any) => {
    return moment.unix(stamp).format('DD MMM');
  }

  onZoom = () => {
    try{
      const actualZoom = this.map.getZoom();
      const newSize = 60/((20 - actualZoom )*2);
      //const resizedIcon = new MapIcon({iconSize: [newSize, newSize ]});      
      //marker.setIcon(resizedIcon );
    }
    catch(err){
      console.log('Map Zoom Error:', err);
    }
  }

  addLayer = (layer:any) => {
    this.map.addLayer(layer);
    layer.clearLayers();
    this.loadMarkers();
  }

  loadMarkers = () => {}

  render() {
    const {title,userData,classes,theme} = this.props;
    const {center,zoom,recordset,maplayer} = this.state;
    //const {recordset,previousset,currentset} = this.state;
    console.log('userData',userData);

    const {bd} = userData ||{};
    //const mcenter:LatLngExpression = center||[8.977850, 39.253099]; 
    //const mpos:LatLngExpression = center||[9.01055, 38.74750];
        
    const mapcenter:LatLngExpression = center ?? DEFAULT_MAP_CENTER;
    //const apexpos:LatLngExpression = [9.01055, 38.74750]; //[6.647991, -0.579113];
    const apextext = `NTRMS Event.`;
    //const bounds = new  L.LatLngBounds([[4.5392525, -3.260786],[11.1748562,	1.2732942]]);
    //const bounds:LatLngBoundsExpression = [[4.5392525, -3.260786],[11.1748562,	1.2732942]];
    //-3.24437008301, 4.71046214438, 1.0601216976, 11.0983409693
    const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    return (
      <PageBase navigation="NTRMS / Map board" subid={(bd||{}).eni}>
      <Box sx={{...s.root}}>
        <Grid container spacing={theme.breakpoints.up('sm')?3:1}>
          <Grid size={{xs:12}}>
            {/* <LiveMap /> */}
            <Paper sx={{...s.boardpaper}}>
              <Box sx={{...s.header}}>{title}</Box>
              <Box sx={{...s.div}}>
                <ResponsiveContainer >
                  <MapContainer 
                    //ref={this.map} 
                    center={center ?? DEFAULT_MAP_CENTER} 
                    zoom={zoom} 
                    scrollWheelZoom={false} 
                    style={{height:'80vh',width:'100%'}} 
                    bounds={bounds}
                    
                  >
                    <TileLayer
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={bounds}
                    />
                    <GeoJSON attribution="&copy; credits due..." data={maplayer} />

                    <Marker position={mapcenter}>
                      <Popup>
                        {apextext}
                      </Popup>
                    </Marker>
                    {/* {recordset.map((record:any, idx:number) => 
                      <Marker key={record.rid} position={record.geo}>
                      <Popup>
                        <Box component='span'>STS:{record.sno}<br/>METER:{record.mno}<br/>DISTRICT: {record.mmd}<br/>MODEL: {record.mtc}<br/>PHASE: {record.mpc}</Box>
                      </Popup>
                    </Marker>
                    )} */}
                    {recordset.filter((r: any) => isValidPosition(r.geo)).map((record:any, idx:number) => 
                    <Marker key={record.mno} position={record.geo} icon={metericons[record.mtc]?.[record.mpc] ?? DefaultIcon}>
                      <Popup>
                        <Box component='span'>STS:{record.sno}<br/>METER:{record.mno}<br/>DISTRICT: {record.mmd}<br/>MODEL: {record.mtc}<br/>PHASE: {record.mpc}</Box>
                      </Popup>
                    </Marker>
                    )}
                  </MapContainer>
                </ResponsiveContainer>
              </Box>
            </Paper>
            
          </Grid>
        </Grid>
      </Box>
      </PageBase>
    );
  }
};

export default Mapboard;
